import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import homeEN from "./features/portfolio/home/Locales/en";
import homeAR from "./features/portfolio/home/Locales/ar";
import newsEN from "./features/portfolio/news/Locales/en";
import newsAR from "./features/portfolio/news/Locales/ar";
import referencesAR from "./features/portfolio/references/Locales/ar";
import referencesEN from "./features/portfolio/references/Locales/en";
import servicesAR from "./features/portfolio/services/Locales/ar";
import servicesEN from "./features/portfolio/services/Locales/en";
import aboutEN from "./features/portfolio/about/Locales/en";
import aboutAR from "./features/portfolio/about/Locales/ar";
import productsAR from "./features/portfolio/products/Locales/ar";
import productsEN from "./features/portfolio/products/Locales/en";
import contactAR from "./features/portfolio/contact/Locales/ar";
import contactEN from "./features/portfolio/contact/Locales/en";
import partnersEN from "./features/portfolio/partners/Locales/en";
import partnersAR from "./features/portfolio/partners/Locales/ar";
import layoutEN from "./components/layouts/Locales/en";
import layoutAR from "./components/layouts/Locales/ar";
import dashboardEN from "./features/dashboard/Locales/en";
import dashboardAR from "./features/dashboard/Locales/ar";
import paginationEN from "./components/ui/pagination/locales/en.json";
import paginationAR from "./components/ui/pagination/locales/ar.json";
import NewsCardEN from "./components/ui/news card/locales/en.json";
import NewsCardAR from "./components/ui/news card/locales/ar.json";

i18n.use(initReactI18next).init({
  resources: {
    EN: {
      home: homeEN,
      news: newsEN,
      references: referencesEN,
      services:servicesEN,
      about:aboutEN,
      products:productsEN,
      partners:partnersEN,
      contact:contactEN,
      layout: layoutEN,
      dashboard: dashboardEN,
      pagination:paginationEN,
      newsCard:NewsCardEN,
    },
    AR: {
      home: homeAR,
      news: newsAR,
      references: referencesAR,
      services:servicesAR,
      about:aboutAR,
      products:productsAR,
      partners:partnersAR,
      contact:contactAR,
      layout: layoutAR,
      dashboard: dashboardAR,
      pagination:paginationAR,
      newsCard:NewsCardAR,
    },
  },
  lng: localStorage.getItem("lang") || "EN",
  fallbackLng: "EN",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
